import React, { useState, useEffect, useReducer, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import { Box, Menu, MenuItem } from "@material-ui/core";
import { Edit as EditIcon, Visibility as ViewIcon } from "@material-ui/icons";
import { ICON_COLOUR } from "../../../../../lib/constants/style_constants";
import Grid from "@material-ui/core/Grid"
import tableIcons, {
  options,
} from "../../../../../components/universal/table_attributes";
import tableReducer, {
  INITIAL_TABLE_STATE,
} from "../../../../../reducers/table_reducer";
import MaterialTable from "material-table";
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import TableAction from "../../../../../actions/table_actions";
import { ToastMessageContext } from "lib/contexts/message_context";
import WorkshopReportService from "lib/services/api/accounts/workshop";
import { downloadPdfFileFromUrl } from "lib/utils/helperFunctions";
import DispatchFiles from "views/Stores/RmvdParts/RemovedParts/DispatchFiles";
import DispatchAccounts from "views/Accounts/PartSales/Sales/DispatchAccounts";
import DownloadIcon from 'assets/DownloadIcon.svg'
import FinanceFiles from "../../../PartSales/Sales/FinanceFiles";
import Files from "views/Accounts/PartSales/Sales/Files";
const useStyles = makeStyles((theme) => ({

  subTitle: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
    marginTop: "20px",
  },


}));



export const downloadAllFileFromUrl = (fileUrls) => {

  for (let i = 0;i < fileUrls.length;i++) {

    const link = document.createElement("a");
    link.href = fileUrls[i];
    link.target = '_blank';
    document.body.append(link);
    link.click();
    document.body.removeChild(link);
  }
}




function SupportingDoc(props) {
  const { financeOrderList, tabName, id, type, salesID } = props
  const classes = useStyles();
  const message = useContext(ToastMessageContext);
  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize } = tableState;
  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null)
  const [data, setData] = useState([])
  const [action, setAction] = useState(null);
  const [currentSelection, setCurrentSelection] = useState({});
  const [name, setName] = useState("")
  // Ui-table column config
  const stockColumnConfig = [
    {
      title: "Item",
      field: "item",
      headerStyle: {
        paddingLeft: "19px",
        textAlign: "left",
      },
      cellStyle: {
        paddingLeft: "19px",
        textAlign: "left",
        width: "50%",
      },
    },
    {
      title: "View",
      field: "state",
      headerStyle: {
        textAlign: "center",
      },
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Download",
      field: "download",
      headerStyle: {
        textAlign: "center",
        paddingRight: "19px",
      },
      cellStyle: {
        textAlign: "center",
        paddingRight: "19px",
      },

    },
  ];

  // tableOptions
  const stockTableOptions = {
    ...options,
    paging: false,

    search: false,
    toolbar: false,


  }

  const downloadFilePdf = async (id, name, docID) => {

    try {
      const params = {
        workshop_order_id: id,
        report: name,
        doc_id: docID
      }


      const params1 = {
        workshop_order_id: id,
        report: name,

      }



      await WorkshopReportService.downloadFiles(name === "customer_order_doc" ? params : params1).then(res => {
        // console.log("id====", docID)
        downloadPdfFileFromUrl(res.file)
      })
      // for downloading file automatically
      message.showToastMessage({
        message: "File downloaded successfully",
        variant: "success",
      });
    } catch (error) {
      message.showToastMessage({
        message: "something went wrong!",
        variant: "error",
      });
    }
  };

  const renderViewIcon = (report) => {
    return (
      <Box>
        <IconButton
        // disabled={!props.permission.write}
        >
          <ViewIcon fontSize="small" onClick={() => {
            // console.log("report=====", report)
            if (report !== undefined && report !== null && report.length != 0) {
              window.open(report.map(document => document.file_path))
            }
            else {
              message.showToastMessage({
                message: "No Report Found.",
                variant: "error",
              })
            }
          }} />
        </IconButton>
      </Box>
    )
  }

  const renderViewRORIcon = (report) => {

    return (
      <Box>
        <IconButton
        >
          <ViewIcon fontSize="small" onClick={() => {
            if (report !== undefined && report !== null) {
              window.open(report.url)
            }
            else {
              message.showToastMessage({
                message: "No Report Found.",
                variant: "error",
              })
            }
          }} />
        </IconButton>
      </Box>
    )
  }
  const handleDeliveryFiles = (id) => {
    return (
      <Box>
        <IconButton
        // disabled={!props.permission.write}
        >
          <ViewIcon fontSize="small" onClick={() => {
            if (id !== null) {
              setAction("view_files")
              setCurrentSelection({ dispatch: id })
            }
            else {

              message.showToastMessage({
                message: "No Report Found.",
                variant: "error",
              })
            }
          }} />
        </IconButton>
      </Box>
    )
  }



  const renderDownloadIcon = (id, name, docID) => {
    return (
      <Box>
        <IconButton
          onClick={() => downloadFilePdf(id, name, docID)}
        >
          <img src={DownloadIcon} height={'16px'} />

        </IconButton>
      </Box>
    )
  }
  // changes needed 
  const renderDownloadRorIcon = (id, report) => {
    return (
      <Box>
        <IconButton
          onClick={() => {
            if (report !== undefined && report !== null) {
              downloadPdfFileFromUrl(report?.download_url)
            }
            else {

              message.showToastMessage({
                message: "No Report Found.",
                variant: "error",
              })
            }
          }}
        >
          <img src={DownloadIcon} height={'16px'} />

        </IconButton>
      </Box>
    )
  }

  const handleDispatch = (name, files) => {
    return (
      <Box>
        <IconButton
        // disabled={!props.permission.write}
        >
          <ViewIcon fontSize="small" onClick={() => {
            setName(name)
            setAction(name)
            setCurrentSelection(files)

          }}


          />
        </IconButton>
      </Box>
    )

  }
  const buildData = (tabName, financeOrderList) => {
    const tabConfig = config[tabName] || [];

    return tabConfig.map(({ item, key, type, key1 }) => {
      let state = "";
      let download = "";

      switch (type) {
        case "dispatch":
          state = handleDispatch(key1, financeOrderList[key]);
          break;
        case "ror":
          state = renderViewRORIcon(financeOrderList[key]);
          download = renderDownloadRorIcon(salesID, financeOrderList[key]);
          break;
        case "view":
          state = renderViewIcon(financeOrderList[key]);
          download = renderDownloadIcon(financeOrderList.id, key);
          break;
        case "download":
          download = renderDownloadIcon(financeOrderList.id, key);
          break;
        case "delivery":
          state = handleDeliveryFiles(financeOrderList[key]);
          break;
        default:
          state = "";
      }

      return { item, state, download };
    });
  };
  const config = {
    Parts: [
      { item: "Internal Files", key: "internal_files", key1: "Internal Files", type: "dispatch" },
      { item: "Sales Order", key: "order_reports", type: "ror" },
      { item: "Customer Acceptance", key: "acceptance_files", key1: "Customer Acceptance", type: "dispatch" },
      { item: "Delivery Files", key: "delivery_files", key1: "view_dispatch", type: "dispatch" },
      { item: "Finance Files", key: "finance", key1: "finance", type: "dispatch" },

    ],
    Core: [
      { item: "Internal Files", key: "internal_files", key1: "Internal Files", type: "dispatch" },
      { item: "Sales Order", key: "order_reports", type: "ror" },
      { item: "Core Ex Repair Reports", key: "core_ex_repair_report", key1: "Core Ex Repair Reports", type: "dispatch" },
      { item: "Core Exchange Reports", key: "core_exchange_report", key1: "Core Exchange Reports", type: "dispatch" },
      { item: "Delivery Files", key: "delivery_note", key1: "Delivery Files", type: "dispatch" },
      { item: "Finance Files", key: "finance", key1: "finance", type: "dispatch" }
    ],
    Workshop: [
      { item: "Commercial Report", key: "commercial_report", type: "view" },
      { item: "Customer Acceptance", key: "proof_of_acceptance", type: "view" },
      { item: "Workshop Report", key: "workshop_report", type: "view" },
      { item: "Cost Breakdown Report CSV", key: "cost_breakdown_report", type: "download" },
      { item: "Delivery Files", key: "dispatch_id", type: "delivery" },
      { item: "Customer Order/s", key: "customer_order_doc", key1: "Customer Order/s", type: "dispatch" },
      { item: "Finance Files", key: "finance", key1: "finance", type: "dispatch" },

    ]
  };

  useEffect(() => {
    if (financeOrderList) {
      const data = buildData(tabName, financeOrderList);
      setData(data);
    }
  }, [financeOrderList, tabName]);




  return (
    <Grid>
      <Typography variant="h6" className={classes.subTitle}>
        Supporting Documents
      </Typography>
      <MaterialTable
        style={{ paddingBottom: "40px" }}
        columns={stockColumnConfig}
        data={data || []}
        isLoading={loading}
        options={stockTableOptions}
        icon={tableIcons}
      />
      {action === 'view_files' && <DispatchFiles handleClose={() => setAction(null)} currentSelection={currentSelection} />}
      {action === 'view_dispatch' && <DispatchAccounts handleClose={() => setAction(null)} salesId={salesID} />}
      {action === 'finance' && <FinanceFiles handleClose={() => setAction(null)} type={type} id={id} open={true} />}

      {["Customer Acceptance", 'Customer Order/s', 'Internal Files', "Core Ex Repair Reports", "Core Exchange Reports", "Delivery Files"].includes(action) && <Files handleClose={() => setAction(null)} name={action} currentSelection={currentSelection} />}
    </Grid>
  );
}

export default SupportingDoc;
